import { FeatureNames } from '@empathy/search-adapter';
import { Dictionary } from '../../utils';

export interface DynamicConfig {
  // Required for the store config state
  consent: boolean;
  currency: string;
  device: string;
  documentDirection: DocumentDirection;
  instance: string;
  lang: string;
  scope: string;
  searchLang: string;
  // Optional for the store config state
  catalog?: string;
  endpoints?: Record<FeatureNames, string>;
  env?: string;
  eventCallbacks?: EventCallbacks;
  filters?: PreSelectedFilters;
  section?: string;
  store?: string;
  warehouse?: string;
  [extra: string]: any;
}

export type DocumentDirection = 'ltr' | 'rtl';

export type EventCallbacks = Partial<Record<ClientEventCallbacks, (data: any) => void>> & Dictionary<(data: any) => void>;

export enum ClientEventCallbacks {
  click = 'click',
  query = 'query',
  add2cart = 'add2cart',
  open = 'open',
  close = 'close',
  clearFilters = 'clearFilters',
  filter = 'filter',
  sort = 'sort',
  columnsChange = 'columnsChange',
  resultsEnd = 'resultsEnd',
  checkout = 'checkout',
  addToWishlist = 'addToWishlist',
  removeFromWishlist = 'removeFromWishlist',
  getWishlist = 'getWishlist'
}

export interface ClientEvent {
  eventName: ClientEventCallbacks;
  data?: any;
  origin?: string;
}

export type PreSelectedFilters = Dictionary<string>;
